import * as React from "react";
import { connect } from "react-redux";

import Helpline from "../../screens/Settings/Helpline/Helpline";
import {
  fetchHelplines,
  AddHelpline,
  EditHelpline,
  helplineSlectedPage
} from "./action";
class HelplineContainer extends React.Component<Props, State> {
  render() {
    return (
      <Helpline
        fetchHelplines={this.props.fetchHelplines}
        HelplineList={this.props.HelplineList}
        AddHelpline={this.props.AddHelpline}
        EditHelpline={this.props.EditHelpline}
        helplineSlectedPage={this.props.helplineSlectedPage}
        HelplineCount={this.props.HelplineCount}
      />
    );
  }
}
function bindAction(dispatch) {
  return {
    fetchHelplines: () => {
      dispatch(fetchHelplines());
    },
    AddHelpline: value => {
      // console.log(value);
      dispatch(AddHelpline(value));
    },
    EditHelpline: value => {
      dispatch(EditHelpline(value));
    },
    helplineSlectedPage: value => {
      dispatch(helplineSlectedPage(value));
    }
  };
}
const mapStateToProps = state => {
  return {
    HelplineList: state.HelplineReducer.HelplineList,
    HelplineCount: state.HelplineReducer.HelplineCount
  };
};

export default connect(
  mapStateToProps,
  bindAction
)(HelplineContainer);
